import { withToolLogging } from "./toolLogger";

const warnRegistrationError = (name, err) => {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.warn(`[webmcp] impossibile registrare ${name}:`, err);
  }
};

/**
 * Registra un tool e ritorna la funzione di cleanup che lo rimuove. Non lancia mai.
 *
 * Contratto WebMCP attuale (document.modelContext e shim): registerTool(tool,
 * { signal }) ritorna una Promise e non esiste unregisterTool: il tool resta
 * registrato finche` il signal non viene abortito. Un eventuale rifiuto della
 * Promise (es. nome duplicato, schema non valido) viene gestito qui, cosi` non
 * finisce come unhandled rejection.
 *
 * Retrocompatibilita` con le implementazioni precedenti (navigator.modelContext):
 * se l'API espone ancora unregisterTool o registerTool ritorna una funzione /
 * un handle con unregister(), vengono usati anche quelli.
 *
 * L'execute viene avvolto con il log di utilizzo (toolLogger). Le opzioni di log
 * (es. `redact`: chiavi con dati personali da oscurare) restano fuori dall'oggetto
 * passato a registerTool, cosi` l'API nativa non riceve chiavi sconosciute.
 */
export const safeRegisterTool = (mc, tool, logOptions = {}) => {
  const loggedTool = {
    ...tool,
    execute: withToolLogging(tool.name, tool.execute, logOptions),
  };
  const controller =
    typeof AbortController !== "undefined" ? new AbortController() : null;

  const legacyUnregister = () => {
    try {
      if (typeof mc.unregisterTool === "function") mc.unregisterTool(tool.name);
    } catch (e) {
      /* ignore */
    }
  };

  // API legacy: rimuove un eventuale omonimo gia` presente.
  legacyUnregister();

  let handle;
  try {
    handle = mc.registerTool(
      loggedTool,
      controller ? { signal: controller.signal } : undefined
    );
    if (handle && typeof handle.then === "function") {
      handle.then(undefined, (err) => warnRegistrationError(tool.name, err));
    }
  } catch (err) {
    warnRegistrationError(tool.name, err);
  }

  return () => {
    if (controller) controller.abort();
    if (typeof handle === "function") {
      handle();
    } else if (handle && typeof handle.unregister === "function") {
      handle.unregister();
    } else {
      legacyUnregister();
    }
  };
};
